import axios from "axios";

let interceptorInstalled = false;

const setAuthToken = () => {
  axios.defaults.withCredentials = true;
  if (interceptorInstalled) {
    return;
  }

  axios.interceptors.request.use((config) => {
    config.withCredentials = true;
    if (config.headers) {
      delete config.headers.Authorization;
      delete config.headers.authorization;
    }
    return config;
  });
  interceptorInstalled = true;
};

export default setAuthToken;
